export const COUNTRY_CONFIG = {
    Afghanistan: {
        currency: "AFN",
        currency_symbol: "؋",
        locale: "fa-AF",
        timezone: "Asia/Kabul",
    },

    Albania: {
        currency: "ALL",
        currency_symbol: "L",
        locale: "sq-AL",
        timezone: "Europe/Tirane",
    },

    Algeria: {
        currency: "DZD",
        currency_symbol: "دج",
        locale: "ar-DZ",
        timezone: "Africa/Algiers",
    },

    Argentina: {
        currency: "ARS",
        currency_symbol: "$",
        locale: "es-AR",
        timezone: "America/Argentina/Buenos_Aires",
    },

    Armenia: {
        currency: "AMD",
        currency_symbol: "֏",
        locale: "hy-AM",
        timezone: "Asia/Yerevan",
    },

    Australia: {
        currency: "AUD",
        currency_symbol: "$",
        locale: "en-AU",
        timezone: "Australia/Sydney",
    },

    Austria: {
        currency: "EUR",
        currency_symbol: "€",
        locale: "de-AT",
        timezone: "Europe/Vienna",
    },

    Bangladesh: {
        currency: "BDT",
        currency_symbol: "৳",
        locale: "bn-BD",
        timezone: "Asia/Dhaka",
    },

    Belgium: {
        currency: "EUR",
        currency_symbol: "€",
        locale: "nl-BE",
        timezone: "Europe/Brussels",
    },

    Brazil: {
        currency: "BRL",
        currency_symbol: "R$",
        locale: "pt-BR",
        timezone: "America/Sao_Paulo",
    },

    Bulgaria: {
        currency: "BGN",
        currency_symbol: "лв",
        locale: "bg-BG",
        timezone: "Europe/Sofia",
    },

    Cambodia: {
        currency: "KHR",
        currency_symbol: "៛",
        locale: "km-KH",
        timezone: "Asia/Phnom_Penh",
    },

    Canada: {
        currency: "CAD",
        currency_symbol: "$",
        locale: "en-CA",
        timezone: "America/Toronto",
    },

    China: {
        currency: "CNY",
        currency_symbol: "¥",
        locale: "zh-CN",
        timezone: "Asia/Shanghai",
    },

    Colombia: {
        currency: "COP",
        currency_symbol: "$",
        locale: "es-CO",
        timezone: "America/Bogota",
    },

    Croatia: {
        currency: "EUR",
        currency_symbol: "€",
        locale: "hr-HR",
        timezone: "Europe/Zagreb",
    },

    CzechRepublic: {
        currency: "CZK",
        currency_symbol: "Kč",
        locale: "cs-CZ",
        timezone: "Europe/Prague",
    },

    Denmark: {
        currency: "DKK",
        currency_symbol: "kr",
        locale: "da-DK",
        timezone: "Europe/Copenhagen",
    },

    Egypt: {
        currency: "EGP",
        currency_symbol: "E£",
        locale: "ar-EG",
        timezone: "Africa/Cairo",
    },

    Finland: {
        currency: "EUR",
        currency_symbol: "€",
        locale: "fi-FI",
        timezone: "Europe/Helsinki",
    },

    France: {
        currency: "EUR",
        currency_symbol: "€",
        locale: "fr-FR",
        timezone: "Europe/Paris",
    },

    Germany: {
        currency: "EUR",
        currency_symbol: "€",
        locale: "de-DE",
        timezone: "Europe/Berlin",
    },

    Greece: {
        currency: "EUR",
        currency_symbol: "€",
        locale: "el-GR",
        timezone: "Europe/Athens",
    },

    HongKong: {
        currency: "HKD",
        currency_symbol: "$",
        locale: "zh-HK",
        timezone: "Asia/Hong_Kong",
    },

    Hungary: {
        currency: "HUF",
        currency_symbol: "Ft",
        locale: "hu-HU",
        timezone: "Europe/Budapest",
    },

    Iceland: {
        currency: "ISK",
        currency_symbol: "kr",
        locale: "is-IS",
        timezone: "Atlantic/Reykjavik",
    },

    India: {
        currency: "INR",
        currency_symbol: "₹",
        locale: "en-IN",
        timezone: "Asia/Kolkata",
    },

    Indonesia: {
        currency: "IDR",
        currency_symbol: "Rp",
        locale: "id-ID",
        timezone: "Asia/Jakarta",
    },

    Iran: {
        currency: "IRR",
        currency_symbol: "﷼",
        locale: "fa-IR",
        timezone: "Asia/Tehran",
    },

    Iraq: {
        currency: "IQD",
        currency_symbol: "ع.د",
        locale: "ar-IQ",
        timezone: "Asia/Baghdad",
    },

    Ireland: {
        currency: "EUR",
        currency_symbol: "€",
        locale: "en-IE",
        timezone: "Europe/Dublin",
    },

    Israel: {
        currency: "ILS",
        currency_symbol: "₪",
        locale: "he-IL",
        timezone: "Asia/Jerusalem",
    },

    Italy: {
        currency: "EUR",
        currency_symbol: "€",
        locale: "it-IT",
        timezone: "Europe/Rome",
    },

    Japan: {
        currency: "JPY",
        currency_symbol: "¥",
        locale: "ja-JP",
        timezone: "Asia/Tokyo",
    },

    Kenya: {
        currency: "KES",
        currency_symbol: "KSh",
        locale: "en-KE",
        timezone: "Africa/Nairobi",
    },

    Malaysia: {
        currency: "MYR",
        currency_symbol: "RM",
        locale: "ms-MY",
        timezone: "Asia/Kuala_Lumpur",
    },

    Mexico: {
        currency: "MXN",
        currency_symbol: "$",
        locale: "es-MX",
        timezone: "America/Mexico_City",
    },

    Nepal: {
        currency: "NPR",
        currency_symbol: "₨",
        locale: "ne-NP",
        timezone: "Asia/Kathmandu",
    },

    Netherlands: {
        currency: "EUR",
        currency_symbol: "€",
        locale: "nl-NL",
        timezone: "Europe/Amsterdam",
    },

    NewZealand: {
        currency: "NZD",
        currency_symbol: "$",
        locale: "en-NZ",
        timezone: "Pacific/Auckland",
    },

    Nigeria: {
        currency: "NGN",
        currency_symbol: "₦",
        locale: "en-NG",
        timezone: "Africa/Lagos",
    },

    Norway: {
        currency: "NOK",
        currency_symbol: "kr",
        locale: "nb-NO",
        timezone: "Europe/Oslo",
    },

    Pakistan: {
        currency: "PKR",
        currency_symbol: "₨",
        locale: "ur-PK",
        timezone: "Asia/Karachi",
    },

    Philippines: {
        currency: "PHP",
        currency_symbol: "₱",
        locale: "en-PH",
        timezone: "Asia/Manila",
    },

    Poland: {
        currency: "PLN",
        currency_symbol: "zł",
        locale: "pl-PL",
        timezone: "Europe/Warsaw",
    },

    Portugal: {
        currency: "EUR",
        currency_symbol: "€",
        locale: "pt-PT",
        timezone: "Europe/Lisbon",
    },

    Qatar: {
        currency: "QAR",
        currency_symbol: "﷼",
        locale: "ar-QA",
        timezone: "Asia/Qatar",
    },

    Romania: {
        currency: "RON",
        currency_symbol: "lei",
        locale: "ro-RO",
        timezone: "Europe/Bucharest",
    },

    Russia: {
        currency: "RUB",
        currency_symbol: "₽",
        locale: "ru-RU",
        timezone: "Europe/Moscow",
    },

    SaudiArabia: {
        currency: "SAR",
        currency_symbol: "﷼",
        locale: "ar-SA",
        timezone: "Asia/Riyadh",
    },

    Singapore: {
        currency: "SGD",
        currency_symbol: "$",
        locale: "en-SG",
        timezone: "Asia/Singapore",
    },

    SouthAfrica: {
        currency: "ZAR",
        currency_symbol: "R",
        locale: "en-ZA",
        timezone: "Africa/Johannesburg",
    },

    SouthKorea: {
        currency: "KRW",
        currency_symbol: "₩",
        locale: "ko-KR",
        timezone: "Asia/Seoul",
    },

    Spain: {
        currency: "EUR",
        currency_symbol: "€",
        locale: "es-ES",
        timezone: "Europe/Madrid",
    },

    SriLanka: {
        currency: "LKR",
        currency_symbol: "₨",
        locale: "si-LK",
        timezone: "Asia/Colombo",
    },

    Sweden: {
        currency: "SEK",
        currency_symbol: "kr",
        locale: "sv-SE",
        timezone: "Europe/Stockholm",
    },

    Switzerland: {
        currency: "CHF",
        currency_symbol: "CHF",
        locale: "de-CH",
        timezone: "Europe/Zurich",
    },

    Thailand: {
        currency: "THB",
        currency_symbol: "฿",
        locale: "th-TH",
        timezone: "Asia/Bangkok",
    },

    Turkey: {
        currency: "TRY",
        currency_symbol: "₺",
        locale: "tr-TR",
        timezone: "Europe/Istanbul",
    },

    UAE: {
        currency: "AED",
        currency_symbol: "د.إ",
        locale: "ar-AE",
        timezone: "Asia/Dubai",
    },

    UK: {
        currency: "GBP",
        currency_symbol: "£",
        locale: "en-GB",
        timezone: "Europe/London",
    },

    Ukraine: {
        currency: "UAH",
        currency_symbol: "₴",
        locale: "uk-UA",
        timezone: "Europe/Kyiv",
    },

    USA: {
        currency: "USD",
        currency_symbol: "$",
        locale: "en-US",
        timezone: "America/New_York",
    },

    Vietnam: {
        currency: "VND",
        currency_symbol: "₫",
        locale: "vi-VN",
        timezone: "Asia/Ho_Chi_Minh",
    },
};